import React from "react";
import { useUserAuth } from "../context/UserAuthContext";

const Guidelines = () => {
  const { userData } = useUserAuth();

  return (
    <>
    {userData?.isActive !== false && (
    <div className="form-items big-page-items" style={{ marginTop: '-10px' }}>
      <p className="login-heading page-heading page-heading-d align-center justify-center">GUIDELINES</p>
      <div className="column scroll-fixed scroll-fixed2 padding-bottom-d guidelines-page-d">
        <div className="class-list scrollable guidelines-content guidelines-content-d">
          {userData?.status === 'Parent' ? (
            <>
              <section className="line-height">
                <p className="bold male-female-stat">1. Navigation Button Functions</p>
                <ol style={{listStyleType: 'lower-alpha', paddingLeft: '14px'}}>
                  <li className="male-female-stat"><strong>Personal Information</strong> - View and edit your basic information</li>
                  <li className="male-female-stat"><strong>Change Password</strong> - Change your password to one of your choice</li>
                  <li className="male-female-stat"><strong>Home</strong> - Return to the dashboard</li>
                  <li className="male-female-stat"><strong>Reload Page</strong> - Refresh the page if experiencing network issues</li>
                  <li className="male-female-stat"><strong>Logout</strong> - Sign out from the application</li>
                </ol>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">2. The Dashboard</p>
                <ul style={{listStyleType: 'none', paddingLeft: '0'}}>
                  <li className="male-female-stat">- <strong>My Kids' Classes</strong> - View all classes your children are enrolled in for the current term</li>
                  <li className="male-female-stat">- <strong>Financial Details</strong> - Check expected fees, payments made, and outstanding balances for each child</li>
                </ul>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">3. Viewing Student Information</p>
                <ol style={{listStyleType: 'lower-alpha', paddingLeft: '14px'}}>
                  <li className="male-female-stat">From the dashboard, view the list of your kids enrolled in classes</li>
                  <li className="male-female-stat">See class details such as class name and section</li>
                  <li className="male-female-stat">Review financial details for each child, including:
                    <ul style={{listStyleType:'disc', paddingLeft: '18px'}}>
                      <li className="male-female-stat"><strong>Expected</strong> - Total fees for the term</li>
                      <li className="male-female-stat"><strong>Actual</strong> - Amount paid</li>
                      <li className="male-female-stat"><strong>Balance</strong> - Outstanding amount</li>
                    </ul>
                  </li>
                </ol>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">4. Notifications</p>
                <p className="male-female-stat">- Click on <strong>Notifications</strong> to view messages or updates from the school administration</p>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">5. Important Notes</p>
                <ul style={{listStyleType: 'none', paddingLeft: '0'}}>
                  <li className="male-female-stat">- You can only view information related to your registered children</li>
                  <li className="male-female-stat">- Contact the school administrator for issues with class enrollment or financial records</li>
                  <li className="male-female-stat">- Ensure your account remains active to access the dashboard</li>
                </ul>
              </section>
            </>
          ) : userData?.status === 'Teacher' ? (
            <>
              <section className="line-height">
              <p className="bold male-female-stat">1. Navigation Button Functions</p>
                <ol style={{listStyleType: 'lower-alpha', paddingLeft: '14px'}}>
                  <li className="male-female-stat"><strong>Personal Information</strong> - View and edit your basic information</li>
                  <li className="male-female-stat"><strong>Change Password</strong> - When a user is created, a basic password is issued for the user to login. Use this to change to the password of your choice.</li>
                  <li className="male-female-stat"><strong>Home</strong> - Go back to the landing page</li>
                  <li className="male-female-stat"><strong>Reload Page</strong> - Reload the page in case of poor or stagnant network connection</li>
                  <li className="male-female-stat"><strong>Logout</strong> - Logout from the app as a user</li>                  
                </ol>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">2. The Dashboard</p>
                <ul style={{listStyleType: 'none', paddingLeft: '0'}}>
                  <li className="male-female-stat">- <strong>My Assigned Subjects</strong> - Shows all subjects assigned to you for the current term</li>
                  <li className="male-female-stat">- Click on any subject to enter/view scores for that class</li>
                </ul>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">3. Entering Student Scores</p>
                <ol style={{listStyleType: 'lower-alpha', paddingLeft: '14px'}}>
                  <li className="male-female-stat">From your dashboard, click on the subject you want to score</li>
                  <li className="male-female-stat">You'll see a list of all students in that class</li>
                  <li className="male-female-stat">For each student, enter:
                    <ul style={{listStyleType:'disc', paddingLeft: '18px'}}>
                      <li className="male-female-stat"><strong>1st CA</strong> (First Continuous Assessment)</li>
                      <li className="male-female-stat"><strong>2nd CA</strong> (Second Continuous Assessment)</li>
                      <li className="male-female-stat"><strong>Exam</strong> (End-of-term Examination)</li>
                    </ul>
                  </li>
                  <li className="male-female-stat">The system automatically calculates totals and grades</li>
                  <li className="male-female-stat">Click <strong>Save All Scores</strong> to store the scores</li>
                </ol>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">4. Notifications</p>
                <p className="male-female-stat">- Click on <strong>Notifications</strong> to view messages or notes from Admin</p>               
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">5. Important Notes</p>
                <ul style={{listStyleType: 'none', paddingLeft: '0'}}>
                  <li className="male-female-stat">- You can only score students for subjects assigned to you</li>
                  <li className="male-female-stat">- Scores can be updated until the term is archived</li>
                  <li className="male-female-stat">- Contact admin if you need subjects reassigned</li>
                </ul>
              </section>
            </>
          ) : userData?.status === 'Admin' || userData?.status === "Cashier" ? (
            <>
              <section className="line-height">
              <p className="bold male-female-stat">1. Navigation Button Functions</p>
                <ol style={{listStyleType: 'lower-alpha', paddingLeft: '14px', lineHeight: '1.7 !important'}}>
                  <li className="male-female-stat"><strong>Personal Information</strong> - View and edit your basic information</li>
                  <li className="male-female-stat"><strong>Change Password</strong> - When a user is created, a basic password is issued for the user to login. Use this to change to the password of your choice.</li>
                  <li className="male-female-stat"><strong>Home</strong> - Go back to the landing page</li>
                  <li className="male-female-stat"><strong>Reload Page</strong> - Reload the page in case of poor or stagnant network connection</li>
                  <li className="male-female-stat"><strong>Logout</strong> - Logout from the app as a user</li>                  
                </ol>
              </section>

              <section className="line-height">
              <p className="bold male-female-stat">2. Admin Dashboard Functions</p>
                <ol style={{listStyleType: 'lower-alpha', paddingLeft: '14px'}}>
                  <li className="male-female-stat"><strong>Manage Sections</strong> - Create, edit or delete school sections (e.g., Morning, Islamiyya)</li>
                  <li className="male-female-stat"><strong>Manage Sessions</strong> - Set up academic years (e.g., 2023/2024)</li>
                  <li className="male-female-stat"><strong>Manage Terms</strong> - Configure terms (e.g., First, Second)</li>
                  <li className="male-female-stat"><strong>Current Term</strong> - Set the current term (and session) for the system</li>
                  <li className="male-female-stat"><strong>Manage Subjects</strong> - Add, edit or remove subjects offered in the school</li>
                  <li className="male-female-stat"><strong>Manage Teachers</strong> - Register teachers and assign roles</li>
                  <li className="male-female-stat"><strong>Manage Students</strong> - Register students</li>
                  <li className="male-female-stat"><strong>Manage Classes</strong> - Set up class structures and assign subjects, students, and teachers</li>
                </ol>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">3. Managing Academic Structure</p>
                <ul style={{listStyleType: 'none', paddingLeft: '0'}}>
                  <li className="male-female-stat"><strong>Sections → Sessions → Terms</strong>:</li>
                  <li className="male-female-stat">- First create Sections (if your school has multiple)</li>
                  <li className="male-female-stat">- Then create Sessions within each section</li>
                  <li className="male-female-stat">- Finally create Terms within each session</li><br />

                  <li className="male-female-stat"><strong>Setting Current Term</strong>:</li>
                  <li className="male-female-stat">- Go to Current Term in the navigation</li>
                  <li className="male-female-stat">- Select the active session and term</li>
                  <li className="male-female-stat">- This determines what teachers see</li><br />

                  <li className="male-female-stat"><strong>Managing Classes</strong>:</li>
                  <li className="male-female-stat">- Register classes through <strong>Manage Classes</strong></li>
                  <li className="male-female-stat">- Click on the view button</li>
                  <li className="male-female-stat">- You will see <strong>Info</strong> which gives a summary of the class</li>
                  <li className="male-female-stat">- Add subjects by selecting <strong>Subjects</strong> from the top navigation</li>
                  <li className="male-female-stat">- After adding subjects, you can assign teachers to the subjects by clicking on the <strong style={{backgroundColor: 'rgb(224, 193, 107)', padding: '1px 5px', borderRadius: '5px'}}>+</strong> button displayed beside every added subject</li>
                  <li className="male-female-stat">- You can add students to the class by selecting <strong>Students</strong> from the navigation at the top.</li>
                </ul>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">4. Managing Teachers</p>
                <ul style={{listStyleType: 'none', paddingLeft: '0'}}>
                  <li className="male-female-stat">- Add teachers through <strong>Manage Teachers</strong></li>
                </ul>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">5. Managing Students</p>
                <ul style={{listStyleType: 'none', paddingLeft: '0'}}>
                  <li className="male-female-stat">- Register students through <strong>Manage Students</strong></li>
                </ul>
              </section>

              <section className="line-height">
                <p className="bold male-female-stat">6. Generating Reports</p>
                <ol style={{listStyleType: 'lower-alpha', paddingLeft: '14px'}}>
                  <li className="male-female-stat"><strong>Student Records → Sections → Sessions → Terms → Classes → Student Results</strong></li>
                  <li className="male-female-stat"><strong>Score Sheets</strong> - Blank templates for teachers to record scores</li>
                  <li className="male-female-stat"><strong>Broad Sheet</strong> - Summary of all class results</li>
                  <li className="male-female-stat"><strong>Student Results</strong> - Individual student report cards</li>
                </ol>
                <p className="male-female-stat">All reports can be generated for any term in any session because this system stores past records.</p>
              </section>
            </>
          ) : (
            <p className="male-female-stat">You don't have permission to view guidelines. Please contact administrator.</p>
          )}
        </div>
      </div>
    </div>
    )}
    </>
  );
};

export default Guidelines;